export enum AssistantMessageTypes {
  OUTPUT_TEXT = "output_text",
  OUTPUT_CONTENT = "output_content",
  TRIAGE_SUMMARY = "triage_summary",
  SOAP_NOTE = "soap_note",
  REFUSAL = "refusal",
  CLINIC_REQUEST = "clinic_request",
  CURAI_REDIRECT = "curai_redirect",
  CARE_PLAN = "care_plan",
  HOME_CARE_PLAN = "home_care_plan",
  OUTREACH = "outreach",
  PROFILE_FORM = "profile_form",
  RX_FLOW_CONSENT = "rx_flow_consent",
  RX_QUESTION = "rx_question",
  RX_QUESTIONNAIRE_START = "rx_questionnaire_start",
  RX_QUESTIONNAIRE_END = "rx_questionnaire_end",
  LOCATION_QUESTION = "location_question",
  RX_RENEWAL_FLOW_CONSENT = "rx_renewal_flow_consent",
  RX_RENEWAL_QUESTION = "rx_renewal_question",
  RX_RENEWAL_QUESTIONNAIRE_START = "rx_renewal_questionnaire_start",
  RX_RENEWAL_QUESTIONNAIRE_END = "rx_renewal_questionnaire_end",
  SUBJECTIVE = "subjective",
  UPSELL = "upsell",
  ASK_USER_QUESTIONS = "ask_user_questions",
  PRE_CLINIC_STEPS = "pre_clinic_steps",
  MEDICATION_HISTORY_REQUEST = "medication_history_request",
  PRE_ASYNC_REQUIREMENTS = "pre_async_requirements",
  SMS_GATED_CONTENT = "sms_gated_content",
  DOCUMENT_PREVIEW = "document_preview",
  COMMENTABLE_CONTENT = "commentable_content",
  ZOCDOC_BOOKING = "zocdoc_booking",
}

export type AssistantMessageType =
  (typeof AssistantMessageTypes)[keyof typeof AssistantMessageTypes];
